import * as React from 'react';
/**
 * @ignore - internal component.
 */

const StepContext = /*#__PURE__*/React.createContext({});

if (process.env.NODE_ENV !== 'production') {
  StepContext.displayName = 'StepContext';
}

export default StepContext;